























































































import {Component, Vue} from "vue-property-decorator";
import {TimeAssistantCollaborator} from "@/entity/TimeAssistantCollaborator";
import {TimeAssistantCollaboratorDto} from "@/dto/TimeAssistantCollaboratorDto";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {MessageJiGuangUserBody} from "@/entity/MessageJiGuangUserBody";
import {JiGuangDto} from "@/dto/JiGuangDto";

@Component({
  components: {},
})
export default class TimeAssistantCollaborat extends Vue {
  tab = 'mails';
  timeAssistantId = this.$route.params.id;
  su = SecurityUtils;
  timeAssistantCollaborators: TimeAssistantCollaborator[] = [];

  async send() {
    for (const value of this.timeAssistantCollaborators) {
      if (!value.isRespond) {
        const messageJiGuangUserBody = new MessageJiGuangUserBody();
        messageJiGuangUserBody.message = '您有一个协作日程待响应';
        messageJiGuangUserBody.jidUsername = value.username;
        messageJiGuangUserBody.name = this.su.getLoginUser().name;
        try {
          await JiGuangDto.sendMessage(messageJiGuangUserBody);
          const nf = this.$q.notify({message: '提醒成功', timeout: 1000,color: 'green'});
        } catch (e) {
          console.log(e);
        }
      }
    }

  }

  async mounted() {
    const timeAssistantCollaborator = new TimeAssistantCollaborator();
    timeAssistantCollaborator.timeAssistantId = this.timeAssistantId as unknown as number;
    const timeAssistantCollaborators = await TimeAssistantCollaboratorDto.findAll(timeAssistantCollaborator);
    timeAssistantCollaborators.forEach(value => {
      if (value.username !== this.su.getLoginUser().username) {
        this.timeAssistantCollaborators.push(value);
      }
    });
  }
}
